import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import "@volue/stitches-core";
import Slot from "../EzContent/Slot.es.js";
import stitches from "../theme.config.es.js";
const styles = stitches.css({
  display: "block",
  fontFamily: "$defaultFont",
  variants: {
    use: {
      primary: {
        color: "$label",
        fontSize: "$label",
        lineHeight: "$label",
        fontWeight: "$label",
        padding: 0
      },
      secondary: {
        color: "$label-small",
        fontSize: "$label-small",
        lineHeight: "$label",
        fontWeight: "$label",
        padding: 0
      }
    },
    position: {
      hidden: { srOnly: null },
      top: { marginBottom: "$label-my" },
      bottom: { marginTop: "$label-my" },
      side: { marginRight: "$label-mx", display: "inline-block" }
    },
    error: { true: {} }
  },
  compoundVariants: [{ error: "true", css: { color: "$negative" } }]
});
const EzLabel = forwardRef(
  ({ as: element = "label", position = null, ...initialProps }, ref) => {
    const { props } = styles({ ...initialProps, position });
    return /* @__PURE__ */ jsx(Slot, { element, slot: "label", ...props, ref });
  }
);
EzLabel.displayName = "EzLabel";
export {
  EzLabel as default
};
//# sourceMappingURL=EzLabel.es.js.map
